import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { saveRegistrationState } from "./regisController";

export default function RegisterDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const initialLoadComplete = useRef(false);
  const initialDataSet = useRef(false); // New flag to track if data was set

  const { username, email, password } = location.state || {};

  const [nik, setNik] = useState("");
  const [fullName, setFullName] = useState("");
  const [alias, setAlias] = useState("");
  const [phone, setPhone] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  useEffect(() => {
    // Try to get data from sessionStorage
    const loadData = () => {
      // Try to get previous data from sessionStorage
      const detailsDataStr = sessionStorage.getItem("register_details_data");
      
      if (detailsDataStr) {
        try {
          const detailsData = JSON.parse(detailsDataStr);
          
          // Only set data if there's actual content
          if (detailsData.nik || detailsData.fullName || detailsData.alias || detailsData.phone) {
            console.log("Loading saved data:", detailsData);
            setNik(detailsData.nik || "");
            setFullName(detailsData.fullName || "");
            setAlias(detailsData.alias || "");
            setPhone(detailsData.phone || "");
            initialDataSet.current = true; // Mark that we've set actual data
          }
        } catch (e) {
          console.error("Error parsing details data:", e);
        }
      }
      const formDataStr = sessionStorage.getItem("register_form_data");
      if (!formDataStr && !location.state?.username) {
        navigate("/register");
        return;
      }
      
      // After a short delay, mark loading as complete
      setTimeout(() => {
        initialLoadComplete.current = true;
      }, 300);};
      loadData();
  }, [navigate, location.state]);
  
  // Save details to sessionStorage
  // useEffect(() => {
  //   const detailsData = {
  //     nik,
  //     fullName,
  //     alias,
  //     phone
  //   };
  //   sessionStorage.setItem("register_details_data", JSON.stringify(detailsData));
  // }, [nik, fullName, alias, phone]);

  // Save data whenever form values change
  useEffect(() => {
    if (!initialLoadComplete.current) {
      return;
    }
    
    // Don't save empty data if we previously loaded valid data but haven't changed anything
    if (initialDataSet.current && !nik && !fullName && !alias && !phone) {
      console.log("Preventing save of empty data when we already loaded valid data");
      return;
    }
    
    const detailsData = {
      nik,
      fullName,
      alias,
      phone
    };
    
    console.log("Saving details data to sessionStorage:", detailsData);
    sessionStorage.setItem("register_details_data", JSON.stringify(detailsData));
  }, [nik, fullName, alias, phone]);


  const handleSubmit = () => {
    const trimmedNik = nik.trim();
    const trimmedFullName = fullName.trim();
    const trimmedAlias = alias.trim();
    const trimmedPhone = phone.trim();

    // Basic required field check
    if (!trimmedNik || !trimmedFullName || !trimmedAlias || !trimmedPhone) {
      setErrorMessage("Harap isi semua field yang wajib diisi.");
      return;
    }

    // NIK harus 16 digit angka
    const nikRegex = /^[0-9]{16}$/;
    if (!nikRegex.test(trimmedNik)) {
      setErrorMessage("NIK harus terdiri dari 16 digit angka.");
      return;
    }

    // Optional: no HP validasi dasar
    const phoneRegex = /^08[0-9]{6,14}$/;
    if (!phoneRegex.test(trimmedPhone)) {
      setErrorMessage("Format nomor HP tidak valid. Harus dimulai dengan '08' dan terdiri dari 8-14 digit.");
      return;
    }

    setErrorMessage("");
    saveRegistrationState({
      nik: trimmedNik,
      fullName: trimmedFullName,
      alias: trimmedAlias,
      phone: trimmedPhone
    });
    const detailsData = {
      nik: trimmedNik,
      fullName: trimmedFullName,
      alias: trimmedAlias,
      phone: trimmedPhone
    };
    
    sessionStorage.setItem("register_details_data", JSON.stringify(detailsData));
    navigate("/preferences");
  };
  const handleBackNavigation = () => {
    const detailsData = {
      nik,
      fullName,
      alias,
      phone
    };
    sessionStorage.setItem("register_details_data", JSON.stringify(detailsData));
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header with back button */}
      <div className="flex items-center justify-between px-4 py-4 pt-8">
        <button
          onClick={handleBackNavigation}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <img src="/icon-back.png" alt="Back" className="h-6 w-6" />
        </button>
        <div className="flex-1" /> {/* Spacer */}
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto pb-32"> {/* Added overflow-y-auto and padding bottom */}
        <div className="flex flex-col items-center px-8 py-4">
          <div className="w-full max-w-md text-left mb-6">
            <img src="/logohallostroke.png" alt="Logo" className="h-12 mb-8" />
            <h1 className="text-2xl font-bold text-gray-900 mb-8">
              Lengkapi data diri Anda
            </h1>
          </div>

          <div className="w-full max-w-md">
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  NIK<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Masukkan NIK"
                  value={nik}
                  onChange={(e) => setNik(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                  maxLength={16}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Nama Lengkap sesuai KTP<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Masukkan nama lengkap sesuai KTP"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Nama Samaran<span className="text-red-500">*</span>
                </label>
                <p className="text-xs text-gray-500 mb-1">
                  untuk menyembunyikan nama Anda pada forum diskusi
                </p>
                <input
                  type="text"
                  placeholder="Masukkan nama samaran"
                  value={alias}
                  onChange={(e) => setAlias(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  No. Whatsapp<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Masukkan no. Whatsapp"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                  maxLength={14}
                />
              </div>

              {errorMessage && (
                <div className="mt-4 mb-4">
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <p className="text-sm font-medium text-red-800">
                          {errorMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <p className="text-xs text-right mt-4">
                <span className="text-red-500">*</span>
                <span className="font-semibold text-black">wajib diisi</span>
              </p>
            </form>
          </div>

          {/* Add extra space at bottom for better scrolling */}
          <div className="h-16"></div>
        </div>
      </div>

      {/* Fixed bottom buttons */}
      <div className="fixed bottom-0 left-0 right-0 bg-white px-8 pb-6 pt-4 shadow-lg border-t border-gray-100">
        <div className="w-full max-w-md mx-auto">
          <button
            onClick={handleSubmit}
            type="button"
            className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition mb-3 disabled:opacity-50 disabled:cursor-not-allowed"
            // disabled={loading}
          >
            Buat Akun
          </button>


        </div>
      </div>
    </div>
  );
}
